<template>
  <div class="album-recommend">
    <templet-factory v-for="(block, key) in blocks" :key="key" 
      :template="block.template" 
      :isShowTitle="true" 
      :list="block.list" 
      :dataTitle="block.title" 
      :dataId="parseInt(block.id)" 
      :clickMore="clickMore"
      :hasMore="parseInt(block.hasmore)" />
  </div>
</template>

<script>
import { albumSetting } from '@/api/detail'
import { openWindow } from '@/api/app'
import TempletFactory from '@/components/TempletFactory'
export default {
  name: 'AlbumRecommend',
  components: {
    TempletFactory
  },
  props: {
    albumid: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      blocks: []
    }
  },
  created () {
    this.init()
  },
  methods: {
    init() {
      albumSetting({ albumid: this.albumid }).then(response=>{
        this.blocks = response.data.data
      })
    },
    clickMore: function (id, title) {
      for (var block of this.blocks) {
        if (block.id != id) {
          continue
        }
        if (block.redirect) {
          if (block.urltype == 0) {
            openWindow(1, block.redirect, '', this)
          } else {
            openWindow(0, block.redirect, '', this)
          }
          return
        }
        openWindow(0, '/more', {id: id, template: block.template, title: title}, this)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.album-recommend{
  margin-top: 10px;
}
</style>
